<script>
  import {
    PlusIcon,
    Edit3Icon,
    XIcon,
    LogInIcon,
    AtSignIcon,
  } from 'vue-feather-icons'
  import {
    rolesComputed,
    branchesComputed
  } from '@state/helpers';
  import Multiselect from 'vue-multiselect'

  export default {
    components: {
      Multiselect,
      PlusIcon,
      Edit3Icon,
      XIcon,
      LogInIcon,
      AtSignIcon,
    },
    props: {
      roles: {
        type: Array,
        required: true
      },
      possibleRoles: {
        type: Array,
        required: true
      },
      possibleBranches: {
        type: Array,
        required: true
      },
      validation: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...rolesComputed,
      ...branchesComputed,
    },
    watch: {
      validation: {
        handler() {

        },
        deep: true
      }
    },
    methods: {
      addRole() {
        this.roles.push(
          {
            is_edit: true,
            role_id: null,
            branch_id: null,
          }
        );
      },
      removeRole(index) {
        this.roles.splice(index, 1)
      },

      toggleEditRole(index, toggle = true) {
        const role = this.roles[index]
        role.is_edit = toggle
        this.$set(this.roles, index, role)
      },
      canUpdateRole(index){
        const role = this.roles[index]
        if (role && role.role_id){
          return true
        }
        return false
      },
      canRemoveRole(index){
        const usableRoles = this.roles.filter(el => el && Object.hasOwnProperty.call(el, 'role_id') && el.role_id > 0  && Object.hasOwnProperty.call(el, 'branch_id') && el.branch_id > 0 )
        if (usableRoles && usableRoles.length > 1){
          return true
        }
        return !this.canUpdateRole(index)
      },
      changeRole(object){
        if (object && object.roleObject  && Object.hasOwnProperty.call(object.roleObject, 'id')){
          object.role_id = object.roleObject.id
        }
      },
      changeBranch(object){
        if (object && object.branchObject  && Object.hasOwnProperty.call(object.branchObject, 'id')){
          object.branch_id = object.branchObject.id
        }
      },
      resolveRoleName(role){
        const fullRole = this.possibleRoles.find(el => el.id === role.role_id)
        if (fullRole){
          return fullRole.name
        }
        return ''
      },
      resolveBranchName(role){
        const fullBranch = this.possibleBranches.find(el => el.id === role.branch_id)
        if (fullBranch){
          return fullBranch.name
        }
        return ''
      },
      canSaveRole(index){
        const role = this.roles[index]
        if (role && role.role_id && role.branch_id){
          return true
        }
        return false
      }
    }
  }
</script>

<template>
  <div class="form-content pt-1">
    <div v-for="(role, index) in roles" :key="index">
      <div
        v-if="!role.is_edit"
        class="edit-form-item my-3"
        :class="{ '!tw-mr-11': !canRemoveRole(index) }">
        <div class="item-info tw-flex tw-flex-row">
          <div class="fl-inline-center left-ct tw-pl-4" style="justify-content: unset">
            <LogInIcon size="1.2x" class="tw-mr-3"/><p class="tx-value mg-b-0 text-bold"> {{ resolveRoleName(role)}}</p>
          </div>
          <div class="fl-inline-center left-ct tw-pl-1" style="justify-content: unset;">
            <AtSignIcon size="1.2x" class="tw-mr-3"/><p class="tx-value mg-b-0 text-bold"> {{ resolveBranchName(role)}}</p>
          </div>
        </div>
        <div class="action-group mg-l-auto tw-flex-shrink-1">
          <button type="button" class="btn btn-icon button-action button-action-positive" @click="toggleEditRole(index)">
            <Edit3Icon size="1x" class="custom-class"></Edit3Icon>
          </button>
          <button
            v-if="canRemoveRole(index)"
            type="button"
            class="btn btn-icon button-action button-action-negative"
            @click="removeRole(index)">
            <XIcon size="1x" class="custom-class"></XIcon>
          </button>
        </div>
      </div>
      <div v-else class="border border-radius-20 my-3 pd-20 bg-gray">
        <div class="group-block">
          <div class="tw-flex tw-flex-col md:tw-flex-row">
            <div class="tw-w-full md:tw-w-1/3">
              <div :class="['form-group mg-b-u', { 'is-invalid': validation['roles.' + index + '.role_id'] }]">
                <label>Roles*</label>
                <Multiselect
                  v-model="roles[index].roleObject"
                  deselect-label="Can't remove this value"
                  track-by="id"
                  label="name"
                  placeholder="Select Role"
                  :class="{
                    'scrollable': possibleRoles.length > 7,
                  }"
                  :options="possibleRoles"
                  :searchable="false"
                  :allow-empty="false"
                  @input="changeRole(roles[index])"
                />
                <span v-if="!validation['roles.' + index + '.role_id']" class="optional">The role that the user will be assigned</span>
                <div class="invalid-feedback">
                  {{ validation['roles.' + index + '.role_id'] }}
                </div>
              </div>
            </div>

            <div class="tw-w-2/12 tw-hidden md:tw-flex tw-justify-center text-center al-self-center">
              <span class="ficon ficon-line-arrow-right"></span>
            </div>

            <div class="tw-w-full md:tw-w-1/3 md:tw-mr-4">
              <div :class="['form-group mg-b-u', { 'is-invalid': (validation['roles.' + index + '.branch_id'] || validation['roles.' + index + '.role_id']) }]">
                <label>Branch*</label>
                <Multiselect
                  v-model="roles[index].branchObject"
                  deselect-label="Can't remove this value"
                  track-by="id"
                  label="name"
                  placeholder="Select Branch"
                  :class="{
                    'scrollable': possibleBranches.length > 7,
                  }"
                  :options="possibleBranches"
                  :searchable="false"
                  :allow-empty="false"
                  :disabled="!roles[index].role_id"
                  @input="changeBranch(roles[index])"
                />
                <span v-if="!validation['roles.' + index + '.branch_id']" class="optional">The branch where the selected role will apply to</span>
                <div class="invalid-feedback">
                  {{ validation['roles.' + index + '.branch_id'] }}
                </div>
              </div>
            </div>

            <div class="tw-w-full md:tw-w-2/12 tw-inline-flex tw-flex-col tw-content-center tw-justify-center tw-items-center">
              <button
                v-if="canUpdateRole(index)"
                type="button"
                class="btn button button-dashed-positive tw-min-w-u xs:tw-min-w-2/5 md:tw-min-w-u tw-w-40 md:tw-w-full lg:tw-w-40 xs:tw-w-auto"
                :disabled="!canSaveRole(index)"
                @click="toggleEditRole(index, false)"> Save </button>
              <span v-if="canUpdateRole(index) && canRemoveRole(index)" class="pd-t-10"/>
              <button
                v-if="canRemoveRole(index)"
                type="button"
                class="btn button button-dashed-danger tw-min-w-u xs:tw-min-w-2/5 md:tw-min-w-u tw-w-40 md:tw-w-full lg:tw-w-40 xs:tw-w-auto"
                @click="removeRole(index)"> Remove </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="group-button">
      <button type="button" class="btn button-bd-dashed" @click="addRole">
        <div class=" fl-al-center">
          <PlusIcon size="1.5x" class="custom-class float-left mr-2"></PlusIcon>
          <span class="item-text">Add Role</span>
        </div>
      </button>
    </div>
  </div>
</template>
